import Noty from 'noty'

Noty.overrideDefaults({
  layout: 'top',
  theme: 'edfinity',
})
